import { render, staticRenderFns } from "./uiSelect.vue?vue&type=template&id=23d4a635"
import script from "./uiSelect.vue?vue&type=script&lang=js"
export * from "./uiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports